import React, { Component } from 'react';
import { useNavigate } from 'react-router';

import BevetelezesForm from './BevetelezesForm.js';

export default function WithNav(props) {
  return <BevetelezesBase {...props} navigate={useNavigate()} />
}

class BevetelezesBase extends Component {
  render() {
    const cardStyle = {
      padding: 20
    };

    return (
      <div>
        <div className="animated fadeIn">
          <div className="card">
            <div className="card-header">
              {this.props.modositas == 'true' ? 'Készletnövekedés módosítása' : 'Új készletnövekedés'}
            </div>
            <div className="row" style={cardStyle}>
              <div className="col-md-12">
                <BevetelezesForm {...this.props} globals={this.props.globals} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
